import map from "lodash/map";
import omit from "lodash/omit";
import { NODE_SERVER_IGNORED_FIELDS } from "Areas/SharedFeatures/types/nodeSource";
import forEach from "lodash/forEach";
export function processNodeTag(tag, lightSourceModels) {
    if (tag.NodeId) {
        return lightSourceModels
            ? {
                GroupId: tag.GroupId,
                NodeId: tag.NodeId,
                NodeWidth: tag.NodeWidth,
                NodeHeight: tag.NodeHeight
            }
            : omit(tag, NODE_SERVER_IGNORED_FIELDS);
    }
    if (tag.Nodes) {
        return lightSourceModels
            ? {
                GroupId: tag.GroupId,
                NodeWidth: tag.NodeWidth,
                NodeHeight: tag.NodeHeight
            }
            : {
                ...omit(tag, NODE_SERVER_IGNORED_FIELDS),
                Nodes: map(tag.Nodes, n => omit(n, NODE_SERVER_IGNORED_FIELDS))
            };
    }
    return tag;
}
function serializeSingleNode(node) {
    var _a, _b;
    const { layout, tag } = node;
    const nodeData = {
        Id: tag.NodeId,
        X: layout.x,
        Y: layout.y,
        Width: layout.width,
        Height: layout.height,
        ParentId: (_a = tag.ParentId) !== null && _a !== void 0 ? _a : null,
        IsGroup: (_b = tag.IsGroup) !== null && _b !== void 0 ? _b : false,
        Ports: []
    };
    return nodeData;
}
export function serializeNodes(graph) {
    const groups = [];
    const nodes = [];
    forEach(graph.nodes.toArray(), (node) => {
        var _a, _b;
        if (graph.isGroupNode(node)) {
            const { layout, tag } = node;
            const groupData = {
                Id: tag.GroupId,
                Name: (_a = tag.GroupName) !== null && _a !== void 0 ? _a : "null",
                Icon: (_b = tag.Icon) !== null && _b !== void 0 ? _b : "null",
                X: layout.x,
                Y: layout.y,
                Width: layout.width,
                Height: layout.height,
                GraphPorts: []
            };
            groups.push(groupData);
        }
        else {
            nodes.push(serializeSingleNode(node));
        }
    });
    return { groups, nodes };
}
